"use client"

import { Badge } from "@/components/atoms"
import { MessageIcon } from "@/icons"
import LocalizedClientLink from "../LocalizedLink/LocalizedLink"
import { useChat} from "@/context/ChatContext";


export const MessageButton = () => {
  const {unreadMessageCount:unreads} = useChat()

  return (
    <LocalizedClientLink href="/user/messages" className="relative">
      <MessageIcon size={20} />
      {Boolean(unreads) && (
        <Badge className="absolute -top-2 -right-2 w-4 h-4 p-0">
          {unreads}
        </Badge>
      )}
    </LocalizedClientLink>
  )
}
